<mat-toolbar
  color="primary"
  class="apearAnimation flex-row flex content-between relative rounded-md"
>
  <div class="absolute left-0 pl-2">
    <span class="font-semibold">Deportistas</span>
  </div>

  <div class="absolute right-0 content-center">
    <ul class="flex-row flex content-center gap-2">
      <li>
        <button mat-icon-button (click)="openDialogCreateUser()">
          <mat-icon>person_add</mat-icon>
        </button>
      </li>
      <li>
        <button mat-icon-button (click)="openDialogQrsDeportistas()">
          <mat-icon>qr_code_2</mat-icon>
        </button>
      </li>
      <li>
        <button mat-icon-button (click)="descargarReporte()">
          <mat-icon>file_download</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <div
    class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2"
  >
    <mat-form-field appearance="outline" class="w-full md:w-auto">
      <mat-label>Nombre o Número de documento</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
      mat-icon-button
        *ngIf="searchString"
        matSuffix
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Disciplina</mat-label>
      <mat-select
        [(ngModel)]="disciplinaSelect"
        (selectionChange)="cambioDiscipinaBuscar()"
      >
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option
          *ngFor="let disciplinaTmp of lstDisciplinas"
          [value]="disciplinaTmp.id"
        >
          {{ disciplinaTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Ordenar por</mat-label>
      <mat-select
        [(ngModel)]="ordenamientoSelect"
        (selectionChange)="cambioDiscipinaBuscar()"
      >
        <mat-option value="0"> Alfabético asc</mat-option>
        <mat-option value="1"> Alfabético desc</mat-option>
        <mat-option value="2"> Fecha de creación asc </mat-option>
        <mat-option value="3"> Fecha de creación desc </mat-option>
      </mat-select>
    </mat-form-field>

    <button
      style="margin-left: 10px"
      (click)="onEnter()"
      mat-raised-button
      color="primary"
    >
      Buscar
    </button>
  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table
      mat-table
      class="table-fixed"
      
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="nombre" sticky>
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element" class="txtMayuscula">
          {{ element.nombre }}
          <mat-icon
            *ngIf="!element.conHorarios"
            matTooltip="Usuario sin horarios"
            matTooltipPosition="after"
            color="warn"
            style="cursor: pointer"
          >
            warning
          </mat-icon>

          <br />
          <small>{{ element.documento }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field
            appearance="outline"
            class="example-full-width pt-2"
            style="max-width: 170px"
          >
            <mat-label>Disciplina</mat-label>
            <mat-select
              [value]="element?.disciplinaId + ''"
              (selectionChange)="cambioDisciplina($event.value, element)"
            >
              <mat-option
                *ngFor="let disciplinaTmp of lstDisciplinas"
                [value]="disciplinaTmp.id"
              >
                {{ disciplinaTmp.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="plan">
        <th mat-header-cell *matHeaderCellDef>Plan</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.plan }} -->
          <mat-form-field
            appearance="outline"
            class="example-full-width pt-2"
            style="max-width: 170px"
          >
            <mat-label>Plan</mat-label>
            <mat-select
              [value]="element?.planId + ''"
              (selectionChange)="cambioPlan($event.value, element)"
            >
              <mat-option
                *ngFor="let planTmp of lstPlanes"
                [value]="planTmp.id"
              >
                {{ planTmp.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="fechaFin">
        <th mat-header-cell *matHeaderCellDef>
          Fecha límite ingreso <small>dd-mm-aa</small>
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            [ngClass]="
              validarFechas(element.fechaIngresoHasta)
                ? 'permiteIngreso'
                : 'noPermiteIngreso'
            "
          >
            {{ element.fechaIngresoHasta | date : "dd-MM-yy" }}
          </span>
          <button
            *ngIf="permiteExtencion"
            title="Extender servicio"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="extenderServicio(element)"
          >
            <mat-icon>next_plan</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [checked]="element.estado"
            (change)="onToggle($event, element)"
          ></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="altoRendimiento">
        <th mat-header-cell *matHeaderCellDef>Alto rendimiento</th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [checked]="element.altoRendimiento"
            (change)="onToggleAltoRendimiento($event, element)"
          ></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef style="min-width: 200px"></th>
        <td mat-cell *matCellDef="let element">
     
         <div class="muestraBotones">

     
            <button
            title="Editar datos del deportista"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="edit(element)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            title="Cambiar foto del deportista"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="fotoUsuario(element)"
          >
            <mat-icon>photo_camera</mat-icon>
          </button>
          <button
            title="Ordenes de compra del usuario"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="ordenesCompraUsuario(element)"
          >
            <mat-icon>checklist</mat-icon>
          </button>
          <button
            *ngIf="permiteExtencion"
            title="Extensiones de servicio del usuario"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="extencionesUsuario(element)"
          >
            <mat-icon>fact_check</mat-icon>
          </button>
          <button
            title="Descargar codigo QR"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="descargarQr(element)"
          >
            <mat-icon>qr_code</mat-icon>
          </button>
          <button
            title="Historial de ingresos del deportista"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="openDialogHistorialIngresos(element)"
          >
            <mat-icon>list_alt</mat-icon>
          </button>
          <button
            title="Editar los horarios del deportista"
            color="primary"
            mat-icon-button
            aria-label="Edit"
            (click)="editHorariosUsuario(element)"
          >
            <mat-icon>edit_calendar</mat-icon>
          </button>
          <button
            *ngIf="element.permiteRegistroIngresoExtraordinario"
            title="Asignar un ingreso extraordinario "
            color="primary"
            mat-icon-button
            aria-label="Edit"
            (click)="asignarIngresoExtraordinario(element)"
          >
            <mat-icon>verified</mat-icon>
          </button>
          <button
            title="Elimiar deportista"
            mat-icon-button
            color="warn"
            aria-label="Delete"
            mat-icon-button
            aria-label="Delete"
            (click)="delete(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      

          <button  class="muestraMenu"
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Menu desplegable con opciones"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              title="Editar datos del deportista"
              color="accent"
              aria-label="Edit"
              (click)="edit(element)"
            >
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>

            <button
              mat-menu-item
              title="Cambiar foto del deportista"
              color="accent"
              aria-label="Edit"
              (click)="fotoUsuario(element)"
            >
              <mat-icon>photo_camera</mat-icon>
              <span>Foto</span>
            </button>
            <button
              mat-menu-item
              title="Ordenes de compra del usuario"
              color="accent"
              aria-label="Edit"
              (click)="ordenesCompraUsuario(element)"
            >
              <mat-icon>checklist</mat-icon>
              <span>Ordenes de compra</span>
            </button>
            <button
              mat-menu-item
              *ngIf="permiteExtencion"
              title="Extensiones de servicio del usuario"
              color="accent"
              aria-label="Edit"
              (click)="extencionesUsuario(element)"
            >
              <mat-icon>fact_check</mat-icon>
              <span>Extender servicio</span>
            </button>
            <button
              mat-menu-item
              title="Descargar codigo QR"
              color="accent"
              aria-label="Edit"
              (click)="descargarQr(element)"
            >
              <mat-icon>qr_code</mat-icon>
              <span>Qr</span>
            </button>
            <button
              mat-menu-item
              title="Historial de ingresos del deportista"
              color="accent"
              aria-label="Edit"
              (click)="openDialogHistorialIngresos(element)"
            >
              <mat-icon>list_alt</mat-icon>
              <span>Ingresos</span>
            </button>
            <button
              mat-menu-item
              title="Editar los horarios del deportista"
              color="primary"
              aria-label="Edit"
              (click)="editHorariosUsuario(element)"
            >
              <mat-icon>edit_calendar</mat-icon>
              <span>Horarios</span>
            </button>
            <button
              mat-menu-item
              *ngIf="element.permiteRegistroIngresoExtraordinario"
              title="Asignar un ingreso extraordinario "
              color="primary"
              aria-label="Edit"
              (click)="asignarIngresoExtraordinario(element)"
            >
              <mat-icon>verified</mat-icon>
              <span>Ingreso extraordinario</span>
            </button>
            <button
              mat-menu-item
              title="Elimiar deportista"
              color="warn"
              aria-label="Delete"
              aria-label="Delete"
              (click)="delete(element)"
            >
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>


          </mat-menu>

         
<!--           <button
            title="prueba boton"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="muestraBotones = !muestraBotones"
          >
            <mat-icon>edit</mat-icon>
          </button> -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
